import type { MarkupData } from '~/repository/modules/category.module';
import {
  COMPONENT_ALIGNCENTER_START,
  COMPONENT_ALIGNCENTER_END,
  COMPONENT_DRAWER_START,
  COMPONENT_DRAWER_END,
  COMPONENT_LAYOUT_TWO_COLUMN_START,
  COMPONENT_LAYOUT_TWO_COLUMN_END,
  COMPONENT_LAYOUT_TWO_COLUMN_INNER_START,
  COMPONENT_LAYOUT_TWO_COLUMN_INNER_END,
  COMPONENT_ACCORDION_START,
  COMPONENT_ACCORDION_END,
} from '~/models/MarkupComponentNames.model';

export const useMarkupComponents = (pageData?: MarkupData | null) => {
  const processedMarkupComponents = computed(() => {
    const components =
      pageData?.PageContent &&
      Array.isArray(pageData.PageContent) &&
      pageData.PageContent.length > 0
        ? pageData.PageContent.filter(
            (componentJson) => !!componentJson?.Component,
          )
        : [];

    let preProcessedComponents = markup_generator_nestInnerMarkupComponents(
      components,
      COMPONENT_ALIGNCENTER_START,
      COMPONENT_ALIGNCENTER_END,
    );

    preProcessedComponents = markup_generator_nestInnerMarkupComponents(
      components,
      COMPONENT_DRAWER_START,
      COMPONENT_DRAWER_END,
    );

    preProcessedComponents = markup_generator_nestInnerMarkupComponents(
      components,
      COMPONENT_LAYOUT_TWO_COLUMN_START,
      COMPONENT_LAYOUT_TWO_COLUMN_END,
    );

    preProcessedComponents = markup_generator_nestInnerMarkupComponents(
      components,
      COMPONENT_LAYOUT_TWO_COLUMN_INNER_START,
      COMPONENT_LAYOUT_TWO_COLUMN_INNER_END,
    );

    preProcessedComponents = markup_generator_nestInnerMarkupComponents(
      preProcessedComponents,
      COMPONENT_ACCORDION_START,
      COMPONENT_ACCORDION_END,
    );

    return preProcessedComponents;
  });

  return { processedMarkupComponents };
};
